module.exports = __webpack_public_path__ + "img/console.558ff04.svg";